<template>
  <b-container>
    <!-- <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row> -->
    <h2>{{ $t("userProfile.editProfile") }}</h2>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.back") }}</b-button>
      </router-link>
    </b-row>

    <base-row-detail
      :label="$t('userProfile.loginName')"
      :value="`${this.model.loginName}`"
    ></base-row-detail>
    <div class="mt-2">
      <b-form-group
        :label="$t('userProfile.namePresentation')"
        label-for="namePresentation"
      >
        <b-col sm="12" md="4" style="padding-left: 0%">
          <b-form-input
            id="namePresentation"
            type="text"
            :placeholder="$t('userProfile.namePresentation')"
            v-model="model.namePresentation"
          />
        </b-col>
      </b-form-group>

      <b-form-group :label="$t('userProfile.email')" label-for="email">
        <b-col sm="12" md="4" style="padding-left: 0%">
          <b-form-input
            id="email"
            type="text"
            :placeholder="$t('userProfile.email')"
            v-model="model.email"
          />
        </b-col>
      </b-form-group>

      <b-form-group :label="$t('userProfile.cellphone')" label-for="cellphone">
        <b-col sm="12" md="4" style="padding-left: 0%">
          <b-form-input
            id="cellphone"
            type="text"
            :placeholder="$t('userProfile.cellphone')"
            v-model="model.cellphone"
          />
        </b-col>
      </b-form-group>

      <b-form-group :label="$t('userProfile.phone')" label-for="phone">
        <b-col sm="12" md="4" style="padding-left: 0%">
          <b-form-input
            id="phone"
            type="text"
            :placeholder="$t('userProfile.phone')"
            v-model="model.phone"
          />
        </b-col>
      </b-form-group>
    </div>

    <b-row>
      <b-col>
        <b-button @click="save()"> Salvar </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import BaseRowDetail from "@/components_rms/base/BaseRowDetail.vue";
export default {
  name: "UserProfileEdit",
  props: {
    placeholder: String,
    readonly: Boolean,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    BaseRowDetail,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Perfil editado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        loginName: "",
        namePresentation: "",
        email: "",
        cellphone: "",
        phone: "",
      },
    };
  },
  created() {
    this.loadProfile();
  },
  computed: {
    getUrlBackToList() {
      return `../profile`;
    },
  },
  methods: {
    loadUserName(type) {
      this.$store.dispatch("userDisplayName", type);
    },
    loadProfile() {
      this.isBusy = true;
      console.log();
      this.$apiScheduler
        .get("/v1/profileDetalied")
        .then((data) => {
          console.log(data.data);
          this.model = data.data;
          this.loadUserName(this.model.namePresentation);
          this.isBusy = false;
          return model;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.logo(error.response);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },

    save() {
      console.log(this.model);
      this.submitted = true;

      this.$apiScheduler
        .post("/v1/profile/Edit", this.model)
        .then((response) => {
          console.log("response.data");
          console.log(response.data);
          this.model = response.data;
          this.$forceUpdate();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
          this.loadUserName(this.model.namePresentation);
        })

        .catch((error) => {
          console.log("error");
          console.log(error);
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              this.alert.error = error.response.data;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>

<style scoped>
.cargo-data-row span {
  color: #c0c1c2;
  line-height: 13px;
  text-transform: none;
  margin-left: 10px;
}
</style>